module.exports = __webpack_public_path__ + "img/history-icon.a351e56c.svg";